export default __webpack_public_path__ + "static/media/Trade.9ce0eb6a.svg";